import "./dist-BTo7lo8F.js";
//#region src/generated/types.gen.ts
var e = {
	BOL: "BOL",
	CSCART: "CSCART",
	LIGHTSPEED: "LIGHTSPEED",
	MAGENTO: "MAGENTO",
	PRESTA: "PRESTA",
	SHOPIFY: "SHOPIFY",
	WOOCOMMERCE: "WOOCOMMERCE"
};
//#endregion
export { e as t };
